import {ShaderMaterial, Vector3, Vector4} from "three";
import commonShader from 'features/apartmentViewer/ApartmentViewer/shaders/layerShader.glsl';

import exposureVertex from "features/apartmentViewer/ApartmentViewer/shaders/exposureMaterial/exposureVertex.glsl";
import exposureFragment from 'features/apartmentViewer/ApartmentViewer/shaders/exposureMaterial/exposureFragment.glsl';

export class ExposureMaterialFactory {
    public static createExposureShader(layerCount: number): ShaderMaterial {
        return new ShaderMaterial({
            uniforms: {
                // Texture input for the shader
                inputTexture: { value: null },

                // Exposure level control
                u_exposure: { value: 0.5 },

                // Debugging texture
                debugTexture: { value: null },

                // Layer-related uniforms
                // Layer textures and metadata
                layerTextures: { value: [] },

                // Shaders does not have dynamic array support, so we need to pass the layer info as a vector4 array
                layerInfo: {
                    value: [
                        new Vector4(0, 0, 0, 0),
                        new Vector4(0, 0, 0, 0),
                        new Vector4(0, 0, 0, 0),
                        new Vector4(0, 0, 0, 0),
                        new Vector4(0, 0, 0, 0),
                        new Vector4(0, 0, 0, 0),
                        new Vector4(0, 0, 0, 0),
                        new Vector4(0, 0, 0, 0),
                        new Vector4(0, 0, 0, 0),
                        new Vector4(0, 0, 0, 0),
                    ]
                },


                // White point adjustment
                u_whitePoint: { value: new Vector3(1, 1, 1) },
                layerCount: { value: layerCount },

                // Time uniform (useful for animations or dynamic effects)
                time: { value: 0 }
            },

            // Vertex Shader: passing texture coordinates and calculating position
            vertexShader: exposureVertex,

            // Fragment Shader: Handles the exposure, tonemapping, and LUT application
            fragmentShader: `${commonShader}${exposureFragment}`,
        });
    }
}
